import { fetchMatches, fetchTeam, fetchTeamTournaments, optaMatchStatus, optaPageSize } from "@/helpers/Opta";
import { selectTeamTournamentCalendar } from "../teamRules";

/**
 * Datos de la página de equipo: ficha con plantel, competiciones que juega y un fixture
 * por competición. La vista revalida el fixture cada 20s en el cliente; esto es el
 * primer render.
 */
export const loadTeamPage = async ({ teamId }) => {
    if (!teamId) return {};

    const [team, calendars] = await Promise.all([
        fetchTeam({ teamId }),
        fetchTeamTournaments({ teamId }),
    ]);

    if (!team) return {};

    return {
        teamData: {
            ...team,
            calendars,
            competitions: calendars ?? [],
            mixedFixture: await loadTeamFixture({ calendars, teamId }),
        },
    };
};

/**
 * Un fixture por competición del equipo, cada uno ordenado por jornada.
 *
 * La temporada la elige `selectTeamTournamentCalendar`, igual que el fixture del cliente
 * en teamFixtureClient.js: antes acá se usaba `tournamentCalendar[0]` y las dos mitades
 * podían quedar mirando temporadas distintas.
 */
const loadTeamFixture = async ({ calendars, teamId }) => {
    const competitions = calendars?.competition ?? [];
    if (competitions.length === 0) return [];

    const fixtures = await Promise.all(
        competitions.map((competition) => {
            const calendarId = selectTeamTournamentCalendar(competition)?.id;
            if (!calendarId) return null;

            return fetchMatches({
                calendarId,
                teamId,
                status: optaMatchStatus.all,
                pageSize: optaPageSize.teamSeason,
            });
        })
    );

    return fixtures.filter(Boolean).map(sortByWeek);
};

/** `sort()` ordena in place y esto viene del feed, así que se copia antes. */
const sortByWeek = (fixture) => ({
    ...fixture,
    match: [...(fixture.match ?? [])].sort((a, b) => a.matchInfo?.week - b.matchInfo?.week),
});
